import { setTerms } from './helpers';

export const setRoomTypes = setTerms('room');
